export const style = {
  label: {
    sx: {
      '&': {
        // primary.text is not workin
        color: '#130F35',
      },
    },
  },
  card: {
    divider: {
      sx: {
        my: 2,
      },
    },
    copybleBlock: {
      sx: {
        color: 'text.primary',
        fontSize: '16px',
      },
    },
    row: {
      sx: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 2,
        paddingBottom: 1,
      },
      Typography: {
        color: 'action.active',
      },
    },
  },
} as const;
